import React from 'react';

const TitleDivideLine = () => {
  return <div style={{ borderBottom: '1px solid rgb(225, 228, 234)', margin: '1rem 0' }}></div>;
};

export default TitleDivideLine;
